import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'

export type RoleProps = ModelProps<Role>

export class Role extends Model<Role> {
  id = Id.none
  @observable accessor name = ''
  @observable accessor description = ''
  @observable accessor workspaceId = Id.none
  @observable accessor isOwnerRole = false
  @observable accessor dateCreated = unixEpoch()
  @observable accessor dateModified = unixEpoch()
}
